import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _SAVE_USER_LOGIN = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.USER_LOGINS.SAVE;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_USER_LOGINS = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.USER_LOGINS.LIST;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _VIEW_USER_LOGIN_PASSWORD = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.USER_LOGINS.VIEW_USER_LOGIN_PASSWORD;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _DELETE_USER_LOGIN = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.USER_LOGINS.DELETE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_LOGIN_STATUS = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.USER_LOGINS.UPDATE_STATUS;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_MODULE = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.MODULES.UPDATE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_USER_LOGIN = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.USER_LOGINS.UPDATE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_USER_PASSWORD = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.USER_LOGINS.UPDATE_PASSWORD;
  return callApi(url, "post", searchData && searchData);
};
